<div class="row" *ngFor="let question of questionMapList; let i = index">
    <h3 class="text-primary" *ngIf="question.questionSortOrder == 1">{{question.categoryAbbreviation}}</h3>
    <div class="col-sm-1 text-end">{{question.questionSortOrder}}</div>
    <div class="col-sm-3"><label class="fw-bold">{{question.question}}</label></div>
    <div class="col-sm-8 p-1">
        <kendo-textarea style="width:100%;" class="border-secondary" id="answer" name="answer"
                        resizable="true"
                        tabindex="{{i + 1}}"
                        (change)="saveAnswer(question)"
                        [(ngModel)]="question.answer"
                        [value]="question.answer"
                        [disabled]="question.isQuestionRetired == true">
        </kendo-textarea>
    </div>
</div>
